import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import { withDevLogin } from '@/features/dev-login/with-dev-login';
import App from './app';

const DevLoginApp = withDevLogin(App);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Theme accentColor="gray">
      <DevLoginApp />
    </Theme>
  </StrictMode>,
);
